var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconRomancePrideLesbianLgbtGlobalGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.9 22.945a1 1 0 0 1-1.444 0L12 18.3a3.062 3.062 0 0 1-.574-3.536h0a3.063 3.063 0 0 1 4.9-.8l.846.845.845-.845a3.064 3.064 0 0 1 4.906.8h0a3.065 3.065 0 0 1-.574 3.536Zm-6.727-6.153h12.005m-9.711 3.037h7.418"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.655 23a11.251 11.251 0 1 1 13.5-12.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.083 15.753a1.5 1.5 0 0 0 1.455-1.864l-.75-3a1.5 1.5 0 0 0-1.455-1.136H.98A11.246 11.246 0 0 0 5 20.8l1-5.047Zm13.906-10.5h-4.064a1.5 1.5 0 0 0-1.455 1.136l-.957 3.823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconRomancePrideLesbianLgbtGlobalGlobe);
export default __webpack_public_path__ + "static/media/streamline-icon-romance-pride-lesbian-lgbt-global-globe.5b90249f.svg";
export { ForwardRef as ReactComponent };